module.exports = __webpack_public_path__ + "img/title1.2bddf4c0.png";